import React from 'react'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className='box-offic-footer'>
        <div className='footer-container'>
            <div className='footer-img'>
            <img src={process.env.PUBLIC_URL + '/images/boxOficLogo-darktheme.png'} alt="BoxOfic" className='img-fluid' />

            </div>
            <div className='footer-message'>
                <p>Helping rights holders, from independent filmmakers to major studios, reach Amazon global audiences across hundreds of devices with the same distribution options and delivery quality available to major motion picture and television studios.
                </p>
                <div className='social-media'>
                <ul>
                    <li><span><a href='https://www.linkedin.com/company/boxofic/about/' target='_blank' rel="noopener noreferrer"><LinkedInIcon />Follow us on LinkedIn</a></span></li>
                    {/* <li><Link to='../license-agreement/video-license-agreement.pdf' target='_blank'>Digital License Agreement</Link></li> */}
                    <li><a href={process.env.PUBLIC_URL + '/license-agreement/video-license-agreement.pdf'} target='_blank' type='application/pdf' rel="noopener noreferrer">Digital License Agreement</a></li>
                </ul>
                <div>© 2023 by Boxoffice Technologies Private Limited</div>
                </div>
            </div>
            <div className='footer-halliv-link'>
                <div>
                    <Link to='https://creators.halliv.com' className='halliv-link'>
                        <img src={process.env.PUBLIC_URL + '/images/hallIv-transparent-logo.png'} alt="HallIv" className='footer-halliV-img img-fluid' />
                    </Link>
                </div>
                <div><Link to='https://creators.halliv.com/' className='halliv-link-tocast'>Cast and promote your film</Link></div>
                <div style={{fontSize:'smaller'}}>A product of Boxoffice Technologies Private Limited</div>
            </div>
        </div>
    </div>
  )
}

export default Footer
